import { slugs } from '@/constants/slugs'
import { TranslateFunction } from '@/utils/translate/translate-client'
import { GiveawayConfig } from '../../types'
import {
  createBaseConfig,
  createStandardTabs,
  createStandardTicketFlow,
  angelImagesUrl,
  staticAssetUrl,
} from '../shared'

export const getSeniorConfig = (t: TranslateFunction): GiveawayConfig => {
  const squareImage = staticAssetUrl('v1754074249/senior/the-senior-alt.webp')
  return createBaseConfig({
    theatricalSlug: slugs.senior,
    heroTitle: t('giveawayHeroTitleSenior', 'Score the Football Experience of a Lifetime!'),
    logoUrl: angelImagesUrl('v1754065302/senior/The_Senior_TT_1.webp'),
    footerLogoUrl: angelImagesUrl('v1754065302/senior/The_Senior_TT_1.webp'),
    // footerBgImage: angelImagesUrl('v1749505430/sketch/dark-pink-bg-01.webp'),
    inTheatersText: t('inTheatersSenior', 'In theaters September 19, 2025'),
    videoImage: angelImagesUrl('v1754084162/senior/image_7.webp'),
    backgroundVideoUrl:
      'https://content.angelstudios.com/senior/Senior_tLoopingVideo_NoAudio_l-en_wNOCAPS_16x9_y20250711_iAA-lowres.mp4',
    share: {
      shareText:
        'Mike Flynt’s comeback story is hitting theaters, and you could win the ultimate football experience! Pre-order your tickets to The Senior and enter to win $50K in cash for you to buy tickets to the Big Game, $10K in cash to buy college football season tickets, and more. #TheSeniorGiveaway — Enter now at [LINK]',
      hashtag: '#SeniorGiveaway',
      shareImage: angelImagesUrl('v1754074249/senior/the-senior-alt.webp'),
      shareImageMobile: angelImagesUrl('v1754074249/senior/the-senior-alt.webp'),
    },

    ticketFlow: createStandardTicketFlow({
      t,
      projectSlug: slugs.senior,
      congratsKey: 'seniorCongratsModalText',
      congratsText:
        "You've earned entries for your chance to win the Football Experience of a Lifetime Giveaway! Complete your checkout to secure your entries.",
      reservationKey: 'seniorReservationCompleteText',
      reservationText: "You've earned entries for your chance to win the Football Experience of a Lifetime Giveaway!",
      noShowtimesKey: 'seniorNoShowtimes',
      noShowtimesText:
        "We're adding new theaters every week. While you wait, pre-order tickets today for your chance to win the Football Experience of a Lifetime Giveaway.",
      landscapeImage: squareImage,
      portraitImage: squareImage,
    }),

    steps: [
      {
        title: t('preOrderTickets', 'Pre-Order Tickets'),
        description: t('preOrderTicketsStep1DescriptionSenior', 'Select your tickets below and get in the game!'),
      },
      {
        title: t('preOrderTicketsStep2', 'Get Your Promo Codes'),
        description: t(
          'preOrderTicketsStep2DescriptionRule',
          'Receive a promo code for each ticket you pre-order, redeemable when showtimes are available.',
        ),
      },
      {
        title: t('preOrderTicketsStep3Sketch', 'Multiply Your Chances To Win'),
        description: t(
          'preOrderTicketsStep3DescriptionSenior',
          'Buy more tickets to multiply your entries! The earlier you preorder your tickets the bigger your entry multiplier becomes. Both moves boost your odds and drive you closer to the end zone!',
        ),
      },
    ],

    tabs: createStandardTabs(t),

    galleryImages: [],
    partnerLogos: [],
  })
}
